import { Box, Button, Typography } from '@mui/material'
import { useCallback, useEffect } from 'react'

import { adminInterface } from '../systems/admin-interface'

export const NotAuthenticatedPage = () => {
  const redirectToLoginPage = useCallback(() => {
    const returnUrl = window.location.href
    location.href = `${phoenix.runtimeConfig.SERVER_URL}/deployments/${phoenix.runtimeConfig.DEPLOYMENT_ID}/auth?returnUrl=${encodeURIComponent(returnUrl)}`
  }, [])

  const sessionRole = adminInterface.useSessionRole()
  useEffect(() => {
    const timeoutRef = setTimeout(() => {
      if (sessionRole === null) redirectToLoginPage()
    }, 2000)

    return () => {
      clearTimeout(timeoutRef)
    }
  }, [redirectToLoginPage, sessionRole])

  return (
    <>
      <Box
        component="div"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          gap: 4,
        }}
      >
        {
          // if user, show text that they do not have the permissions to access this page, otherwise show reddirect text
          sessionRole === 'user' ? (
            <Typography variant="h4">You do not have the permissions to access this page</Typography>
          ) : (
            <span>
              <Typography variant="h4">You are not authenticated</Typography>
              <Typography variant="body1">
                You're going to be redirected to the login page. If you're not redirected, click the button below.
              </Typography>

              <Button variant="contained" onClick={redirectToLoginPage}>
                Log In
              </Button>
            </span>
          )
        }
      </Box>
    </>
  )
}
